import classNames from 'classnames'
import { ISkeletonProps } from '.'

const SkeletonCircle = ({ w, h, className }: ISkeletonProps) => {
  return (
    <div
      style={{
        width: w,
        height: h,
      }}
      className={classNames('animate-pulse rounded-full bg-gray-100', className)}
    ></div>
  )
}

export default SkeletonCircle
